<template>
  <div class="px-5 py-5">
    <div class="flex flex-col center-content mb-7">
      <h2 class="font-bold text-center mb-5">Representatives</h2>
      <button @click="openModal" type="button" class="mx-auto inline-flex items-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-pink-500 hover:bg-pink-700 focus:outline-none focus:outline-none  focus:ring-pink-200">
        <i class="fas fa-calendar mr-2"></i> Add Representative
      </button>
      <representative-modal :is-open="isOpen" :states="this.states"/>
    </div>

    <div class="my-6">&nbsp;</div>

    <div class="flex flex-col space-y-3 xl:space-y-0">
      <representative-list v-for="representative in representatives" :key="representative.id" :representative="representative"/>
    </div>
  </div>
</template>

<script>
import RepresentativeList from "./RepresentativeList";
export default {
  components: {RepresentativeList},
  props: {
    representatives: null,
    states: null,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    openModal() {
      this.emitter.emit('open-modal')
    },
  }
}
</script>

<style scoped>

</style>
